import { useEffect, useState } from "react";
import { Alert } from "antd";
import { WifiOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * OfflineIndicator Component
 * Displays a banner when the user loses internet connection
 * Automatically hides when connection is restored
 */
export default function OfflineIndicator() {
  const { t } = useTranslation();
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setShowOfflineMessage(false);
    };

    const handleOffline = () => {
      setShowOfflineMessage(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!showOfflineMessage) return null;

  return (
    <Alert
      message={t("messages.offline")}
      description={t("messages.offlineDescription")}
      type="warning"
      banner
      closable
      icon={<WifiOutlined />}
      onClose={() => setShowOfflineMessage(false)}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
      }}
    />
  );
}
